import { memo } from 'react';
import type { WorkOrderSort } from '../../../../../enums/workOrderSort';
import type { WorkOrderStatus } from '../../../../../enums/workOrderStatus';
import TruncatedText from '../../../../../shared/components/TruncatedText';
import { STATUS_LABELS } from '../../constants';
import ColumnSortPopover from './ColumnSortPopover';
import styles from './StatusColumn.module.scss';

interface ColumnHeaderProps {
  status: WorkOrderStatus;
  headingId: string;
  count: number;
  sort: WorkOrderSort;
  onSortChange: (status: WorkOrderStatus, sort: WorkOrderSort) => void;
}

// The chip only shows on hover/focus; screen readers always get the count from the heading.
const ColumnHeader = ({ status, headingId, count, sort, onSortChange }: ColumnHeaderProps) => (
  <header className={styles.columnHeader}>
    <h2 id={headingId} className={styles.columnTitle}>
      <TruncatedText text={STATUS_LABELS[status]} />
      <span className={styles.visuallyHidden}>{`, ${count} work order${count === 1 ? '' : 's'}`}</span>
    </h2>
    <span className={styles.columnCount} aria-hidden>
      {count}
    </span>
    <ColumnSortPopover status={status} sort={sort} onSortChange={onSortChange} />
  </header>
);

export default memo(ColumnHeader);
